/**
 * Valida se um celular tem 10 ou 11 dígitos (DDD + número)
 */
export const celularValido = (celular) => {
  if (!celular) return false;
  const digits = celular.replace(/\D/g, '');
  return digits.length >= 10 && digits.length <= 11;
};

/**
 * Retorna string "De até Ate" conforme RetornaIntervalo do Delphi
 */
export const retornaIntervalo = (de, ate) => `${de} até ${ate}`;

/**
 * Limita texto a 160 caracteres (SMS limit)
 */
export const SMS_MAX_CHARS = 160;

export const contarCaracteres = (texto) => SMS_MAX_CHARS - (texto ? texto.length : 0);
